module.exports = require('instantsearch.js/cjs/widgets');
